import { render, staticRenderFns } from "./AmpuRanking.vue?vue&type=template&id=1e32c144&scoped=true&"
import script from "./AmpuRanking.vue?vue&type=script&lang=js&"
export * from "./AmpuRanking.vue?vue&type=script&lang=js&"
import style0 from "./AmpuRanking.vue?vue&type=style&index=0&id=1e32c144&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e32c144",
  null
  
)

export default component.exports